import { Dialog } from '@mui/material';
import React from 'react';
import { getFormatedDate } from '../../../concessionApproval/common';
import { ReactComponent as CrossIcon } from "../../../../../../../assets/img/svg/CrossIcon.svg";
import { AGridColDef } from '../../../../common/data-grid/ADataGridColDef';
import ADataGrid from '../../../../common/data-grid/ADataGrid';
import AButton from '../../../../common/form-fields-mui/AButton';
import { gridStyles, gridComponents } from '../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { formattedPrice } from '../../utils';

const FullBreakupDialog = ({
    open,
    setOpen,
    data,
    amountToBePaid
}) => {

    const closeDialog = () => setOpen(false);

    const columns = [

        new AGridColDef('description', 'Item Type', false)
            .setMinWidth(110)
            .setFlex(0.9)
            .editable(false)
            .setValueGetter(params => params?.value),

        new AGridColDef('dueDate', 'Due Date', false)
            .setMinWidth(110)
            .setFlex(0.8)
            .editable(false)
            .setValueGetter(params => getFormatedDate(params?.value)),

        new AGridColDef('term', 'Term', false)
            .setMinWidth(110)
            .setFlex(0.6)
            .editable(false)
            .setValueGetter(params => params?.value),

        new AGridColDef('courseId', 'Course ID', false)
            .setMinWidth(110)
            .setFlex(0.7)
            .editable(false)
            .setValueGetter(params => params?.value),

        new AGridColDef('itemType', 'Description', false)
            .setMinWidth(110)
            .setFlex(1)
            .editable(false)
            .setValueGetter(params => params?.value),

        new AGridColDef('totalBalanceAmount', 'Item Amount', false)
            .setMinWidth(110)
            .setFlex(0.8)
            .columnAlign('right')
            .editable(false)
            .setValueGetter(params => formattedPrice(params?.value)),

        new AGridColDef('totalNetPayableAmount', 'Net Payable', false)
            .setMinWidth(110)
            .setFlex(0.8)
            .columnAlign('right')
            .editable(false)
            .setValueGetter(params => formattedPrice(params?.value)),
    ]

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth='md'
        >
            <div className='p-4'>
                <div className='d-flex justify-content-between mb-4'>
                    <div className='view-full-breakup-card-heading'>Payment collection breakup</div>
                    <CrossIcon onClick={closeDialog} />
                </div>

                <ADataGrid
                    removeWrapperContainer
                    rows={data || []}
                    columns={columns}
                    rowId={(row) => row.itemType}
                    rowHeight={50}
                    loading={false}
                    components={{
                        ...gridComponents
                    }}
                    sx={gridStyles}
                    autoHeight
                    hidePagination
                />

                <div className='d-flex justify-content-between view-full-breakup-card-heading my-4'>
                    <div>Amount to be paid</div>
                    <div>{formattedPrice(amountToBePaid)}</div>
                </div>

                <AButton
                    variant="primary_filled"
                    onClick={closeDialog}
                    className='no-ml-btn'
                >
                    Okay
                </AButton>
            </div>

        </Dialog>
    );
}

export default FullBreakupDialog;